import { render, staticRenderFns } from "./NewBroadcastMessage.vue?vue&type=template&id=e517a1c8&scoped=true"
import script from "./NewBroadcastMessage.vue?vue&type=script&lang=js"
export * from "./NewBroadcastMessage.vue?vue&type=script&lang=js"
import style0 from "./NewBroadcastMessage.vue?vue&type=style&index=0&id=e517a1c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e517a1c8",
  null
  
)

export default component.exports